/** Centralized rarity styling — single source of truth for joker/item card styling. */

export const RARITY_COLORS: Record<string, string> = {
  common: 'border-white/20 bg-white/5',
  uncommon: 'border-green-400/40 bg-green-500/10',
  rare: 'border-blue-400/40 bg-blue-500/10',
  legendary: 'border-amber-400/40 bg-amber-500/10',
};

export const RARITY_BADGE_COLORS: Record<string, string> = {
  common: 'bg-white/20 text-white/60',
  uncommon: 'bg-green-500/20 text-green-300',
  rare: 'bg-blue-500/20 text-blue-300',
  legendary: 'bg-amber-500/20 text-amber-300',
};

export const RARITY_STYLE_EXPANDED: Record<string, { border: string; bg: string; text: string }> = {
  common: { border: 'border-white/20', bg: 'bg-white/5', text: 'text-white/60' },
  uncommon: { border: 'border-green-400/40', bg: 'bg-green-500/10', text: 'text-green-300' },
  rare: { border: 'border-blue-400/40', bg: 'bg-blue-500/10', text: 'text-blue-300' },
  legendary: { border: 'border-amber-400/40', bg: 'bg-amber-500/10', text: 'text-amber-300' },
};
